import {
  Box,
  Button,
  Card,
  ClosableChips,
  Flex,
  Grid,
  Loader,
  NoData,
  Pagination,
  SearchBox,
  Text,
  Toastify,
} from "atoms";
import React, { useCallback, useEffect, useState } from "react";
import Table from "molecules/Table";
import MemoEyeShowIcon from "assets/icons/EyeShow";
import MemoFilter from "assets/icons/Filter";
import { Chips, Filter } from "molecules";
import { useSort } from "hooks/useSort";
import { usePageNumber, usePageSize } from "hooks/usePageNumber";
import { usePropsoch } from "contexts/Propsoch";
import { format } from "date-fns";
import {
  PAGE_SIZE,
  PROPERTY_PUBLISH_STATUS,
  PROPERTY_STATUS,
} from "utils/constants";
import MemoAdd from "assets/icons/Add";
import { useNavigate, useSearchParams } from "react-router-dom";
import MemoArchive from "assets/icons/Archive";
import { CommentsModal, ConfirmationModal } from "molecules/Modals";
import MemoCircleMinusIcon from "assets/icons/CircleMinusIcon";
import MemoCircleCheckIcon from "assets/icons/CircleCheckIcon";
import { useLocationQueryAdd } from "hooks/useLocationQuery";
import { debounce, optionFetch } from "utils/utilities";
import api from "utils/api";

import MemoComments from "assets/icons/Comments";
import MemoDownload from "assets/icons/Download";

const containerProps = {
  fontSize: "1.4rem",
  fontWeight: "600",
};

const getChip = ({ propertyLastStep, status }) => {
  switch (status) {
    case PROPERTY_PUBLISH_STATUS.drafted: {
      return <Chips title="Drafted" variant="drafted" />;
    }
    case PROPERTY_PUBLISH_STATUS.published: {
      return <Chips title="Published" variant="published" />;
    }
    case PROPERTY_PUBLISH_STATUS.unpublished: {
      return <Chips title="Unpublished" variant="unpublished" />;
    }
    case PROPERTY_PUBLISH_STATUS.progress: {
      return <Chips title="In Progress" variant="progress" />;
    }
    case PROPERTY_PUBLISH_STATUS.completed: {
      return <Chips title="Completed" variant="drafted" />;
    }
    case PROPERTY_PUBLISH_STATUS.revert: {
      return <Chips title="Reverted" variant="unpublished" />;
    }
    default:
      break;
  }
};

const Properties = () => {
  const {
    state: { userRole },
    actions: { getPropertyListing, changePublishStatus, changeArchiveStatus },
  } = usePropsoch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setParam = useLocationQueryAdd();

  const [search, setSearch] = useState("");
  const [showFilter, setsShowFilter] = useState(false);

  const [locations, setLocations] = useState([]);
  const [micromarkets, setMicromarkets] = useState([]);
  useEffect(() => {
    // typology
    optionFetch("/micromarkets/get", "name", "id").then((data) => {
      setMicromarkets(data);
    });
    // typology
    optionFetch("/locations/get", "name", "id").then((data) => {
      setLocations(data);
    });
  }, []);

  // fields
  const [propertyListing, setPropertyListing] = useState([]);
  const [propertyListingLoading, setPropertyListingLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const sort = useSort();
  const page = Number(usePageNumber());
  const pageSize = Number(usePageSize());
  const locationFilter = searchParams.get("location");
  const isPublishedFilter = searchParams.get("isPublished");
  const draftedFilter = searchParams.get("drafted");
  const revertedFilter = searchParams.get("reverted");
  const micromarketFilter = searchParams.get("micromarket");
  const searchFilter = searchParams.get("search");
  const statusFilter = searchParams.get("status");
  const projectTypeFilter = searchParams.get("projectType");

  // filterParamHandler starts
  const filterParamHandler = useCallback(() => {
    const params = {
      location: locationFilter,
      isPublished: isPublishedFilter,
      drafted: draftedFilter,
      reverted: revertedFilter,
      micromarket: micromarketFilter,
      search: searchFilter,
      status: statusFilter,
      pt: projectTypeFilter,
    };

    return params;
  }, [
    locationFilter,
    isPublishedFilter,
    micromarketFilter,
    searchFilter,
    draftedFilter,
    revertedFilter,
    statusFilter,
    projectTypeFilter,
  ]);

  // fetch property Listing
  const fetchPropertyListing = useCallback(() => {
    setPropertyListingLoading(true);
    getPropertyListing({
      sortBy: sort?.split(":")?.[0] || "createdAt",
      order: sort?.split(":")?.[1] || "desc",
      limit: pageSize,
      page: page,
      ...filterParamHandler(),
    })
      .then((data) => {
        setPropertyListing(data?.rows);
        setTotal(data?.count);
      })
      .finally(() => {
        setPropertyListingLoading(false);
      });
  }, [getPropertyListing, page, pageSize, sort, filterParamHandler]);

  useEffect(() => {
    // debounce(fetchPropertyListing);
    fetchPropertyListing();
  }, [fetchPropertyListing]);

  const handlePublishChange = useCallback(
    (id, status, name, comment) => {
      changePublishStatus(id, status, name, comment).finally(() => {
        fetchPropertyListing();
      });
    },
    [changePublishStatus, fetchPropertyListing]
  );

  const handleArchiveChange = useCallback(
    (id, status, name) => {
      changeArchiveStatus(id, status, name).finally(() => {
        fetchPropertyListing();
      });
    },
    [changeArchiveStatus, fetchPropertyListing]
  );

  //
  const [publishModal, setPublishModal] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);
  const [excelModal, setExcelModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);

  // status, type & typology fetch

  const [type, setType] = useState([]);

  useEffect(() => {
    // type
    if (projectTypeFilter && type?.length === 0) {
      optionFetch("/propertytypes/get", "name", "id").then((data) => {
        setType(data);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectTypeFilter]);

  const getPropertyTypeLabel = useCallback(
    (val) => {
      return type?.find((i) => i?.value?.toString() === val)?.label || "";
    },
    [type]
  );

  const exportToExcelHandler = async (type, propertyId) => {
    let reqData = {};
    if (type === "all") {
      reqData.type = "all";
      reqData.propertyId = 0;
    } else {
      reqData.type = "single";
      reqData.propertyId = propertyId;
    }
    try {
      const { data } = await api("/properties/download ", {
        method: "post",
        data: reqData,
      });
      Toastify(
        "success",
        "Please ensure to check your email regularly as data generation time may vary depending on the size."
      );
      return data;
    } catch (e) {
      Toastify("error", e);
      console.error(e);
    }
  };

  return (
    <Box>
      <Flex justifyContent="space-between" aI="center">
        <Text color="primary.900" fontSize="2.4rem" fontFamily="NeometricBold">
          Properties
          <Text
            as="span"
            fontSize="1.6rem"
            fontFamily="NeometricRegular"
            pl="1rem"
          >
            {propertyListing?.length || 0} Properties
          </Text>
        </Text>
        <Button
          variant="primary"
          width="fit-content"
          px="2rem"
          height="4.8rem"
          onClick={() => navigate("add")}
        >
          <Flex justifyContent="center" alignItems="center" gridGap="2rem">
            <MemoAdd />
            Add New Property
          </Flex>
        </Button>
      </Flex>
      {/* properties listing */}
      <Card my="2.4rem" overFlowX="scroll">
        <Flex mb="2.4rem" alignItems="center">
          <SearchBox
            value={search}
            onChange={(e) => {
              setParam("page", undefined);
              setSearch(e?.currentTarget?.value);
              const value = e?.currentTarget?.value;
              debounce(() => {
                setParam("search", value);
              });
            }}
            onClose={() => {
              setSearch("");
              setParam("search", "");
            }}
            placeholder="Search"
            style={{ width: "30rem" }}
            removeValidationIcon={!search}
          />
          <Grid
            placeItems="center"
            height="4.8rem"
            width="6.8rem"
            borderRadius="1rem"
            border="1px solid"
            borderColor="primary.900"
            color="primary.900"
            ml="2.4rem"
            cursor="pointer"
            onClick={() => setsShowFilter(!showFilter)}
          >
            <MemoFilter height="1.8rem" width="1.8rem" />
          </Grid>
          {showFilter && (
            <Box position="absolute" zIndex={2} top="6rem">
              <Filter
                onClose={() => {
                  setsShowFilter(false);
                  setSearch("");
                }}
                locations={locations}
                micromarkets={micromarkets}
              />
            </Box>
          )}
          {(locationFilter || micromarketFilter || isPublishedFilter) && (
            <Text
              color="secondary.700"
              fontSize="1.6rem"
              fontFamily="NeometricBold"
              ml="2.4rem"
              cursor="pointer"
              onClick={() => {
                setParam("location", "");
                setParam("micromarket", "");
                setParam("isPublished", "");
              }}
            >
              Clear All
            </Text>
          )}
          {userRole?.isSuperadmin && (
            <Grid ml="5rem">
              <Button
                variant="primary"
                width="fit-content"
                px="2rem"
                height="4.8rem"
                onClick={() => {
                  setExcelModal({
                    onClose: () => setExcelModal(false),
                    icon: {
                      Icon: MemoArchive,
                      ICprops: { color: "accents.100" },
                    },
                    textOne: "Are you sure you want to",
                    textTwo: "export the data into excel for all properties?",
                    onConfirm: () => {
                      exportToExcelHandler("all");
                      setExcelModal(false);
                    },
                  });
                }}
              >
                Export to Excel
              </Button>
            </Grid>
          )}
        </Flex>

        <Flex mb="2.4rem" gridGap="1rem">
          {locationFilter && (
            <ClosableChips
              name={
                locations?.find((i) => i?.value?.toString() === locationFilter)
                  ?.label || ""
              }
              onClick={() => {
                setParam("location", "");
              }}
            />
          )}
          {micromarketFilter && (
            <ClosableChips
              name={
                micromarkets?.find(
                  (i) => i?.value?.toString() === micromarketFilter
                )?.label || ""
              }
              onClick={() => {
                setParam("micromarket", "");
              }}
            />
          )}
          {
            {
              true: (
                <ClosableChips
                  name="Published"
                  onClick={() => {
                    setParam("isPublished", "");
                  }}
                />
              ),
              false: (
                <ClosableChips
                  name="Unpublished"
                  onClick={() => {
                    setParam("isPublished", "");
                  }}
                />
              ),
            }[isPublishedFilter]
          }
          {
            {
              true: (
                <ClosableChips
                  name="Drafted"
                  onClick={() => {
                    setParam("drafted", "");
                  }}
                />
              ),
            }[draftedFilter]
          }
          {
            {
              true: (
                <ClosableChips
                  name="Reverted"
                  onClick={() => {
                    setParam("reverted", "");
                  }}
                />
              ),
            }[revertedFilter]
          }
          {
            {
              [PROPERTY_PUBLISH_STATUS.completed]: (
                <ClosableChips
                  name="Completed"
                  onClick={() => {
                    setParam("status", "");
                  }}
                />
              ),
              [PROPERTY_PUBLISH_STATUS.progress]: (
                <ClosableChips
                  name="Progress"
                  onClick={() => {
                    setParam("status", "");
                  }}
                />
              ),
            }[statusFilter]
          }
          {projectTypeFilter && (
            <ClosableChips
              name={getPropertyTypeLabel(projectTypeFilter)}
              onClick={() => {
                setParam("projectType", "");
              }}
            />
          )}
        </Flex>

        <Loader loading={propertyListingLoading}>
          <Table
            tableHeader={[
              { name: "ID", sortKey: "id", containerProps },
              {
                name: "Property Name",
                sortKey: "propertyName",
                containerProps,
              },
              {
                name: "Project Type",
                sortKey: "projectType",
                containerProps,
              },
              { name: "Created Date", sortKey: "createdAt", containerProps },
              {
                name: "Status",
                containerProps,
              },
              { name: "Actions", containerProps, rightAligned: true },
            ]}
            // tableHeader={columns.map(({ title, rightAligned, sortKey }) => ({
            //   name: title,
            //   rightAligned,
            //   sortKey,
            //   containerProps: {
            //     fontSize: "1.4rem",
            //     fontWeight: "600",
            //   },
            // }))}
            borderColor="neutral.500"
          >
            {propertyListing?.map((property, index) => (
              <tr key={index}>
                {/* property id */}
                <td>{property?.id}</td>
                {/* market */}
                {/* <td>{property?.micromarketId}</td> */}
                {/* micro market */}
                {/* <td>{property?.micromarketId}</td> */}
                {/* property name */}
                <td>{property?.name}</td>
                {/* area type */}
                <td>{property?.projectType || "-"}</td>
                {/* rera number */}
                {/* <td>
                  <Flex maxWidth="24rem" css={{ overflowWrap: "anywhere" }}>
                    {property?.reraNumber || "-"}
                  </Flex>
                </td> */}
                {/* date */}
                <td>
                  <Box whiteSpace="nowrap">
                    {property?.createdAt &&
                      format(new Date(property?.createdAt), "dd MMM, yyyy")}
                  </Box>
                </td>

                {/* status  */}
                <td>
                  {/* <Box whiteSpace="nowrap"> */}
                  {getChip({
                    propertyLastStep: property?.[PROPERTY_STATUS.legal],
                    status: property?.status,
                  })}
                  {/* </Box> */}
                </td>
                {/* actions */}
                <td>
                  <Grid
                    gridAutoFlow="column"
                    gridGap="1.8rem"
                    justifyContent="start"
                    alignItems="center"
                    color="neutral.600"
                  >
                    <>
                      {(userRole?.isAdmin ||
                        userRole?.isSuperadmin ||
                        userRole?.isMaker) && (
                        <>
                          {!property.status?.includes(
                            PROPERTY_PUBLISH_STATUS.drafted
                          ) ? (
                            <Button
                              height="4.3rem"
                              variant={"primary"}
                              px="2rem"
                              width="13rem"
                              disabled={
                                !property?.[PROPERTY_STATUS.legal] ||
                                property?.status ===
                                  PROPERTY_PUBLISH_STATUS.published
                              }
                              onClick={() => {
                                setPublishModal({
                                  onClose: () => setPublishModal(false),
                                  icon: {
                                    Icon: MemoCircleCheckIcon,
                                    ICprops: { color: "secondary.500" },
                                  },
                                  textOne: "Are you sure you want to",
                                  textTwo: "draft",
                                  textThree: `the property ${property?.name}`,
                                  onConfirm: () => {
                                    handlePublishChange(
                                      property?.id,
                                      PROPERTY_PUBLISH_STATUS.drafted,
                                      property?.name
                                    );
                                    setPublishModal(false);
                                  },
                                });
                              }}
                            >
                              Draft
                            </Button>
                          ) : (
                            <Button
                              height="4.3rem"
                              variant={"primaryOutline"}
                              disabled={!property?.[PROPERTY_STATUS.legal]}
                              px="2rem"
                              width="13rem"
                              onClick={() => {
                                setPublishModal({
                                  onClose: () => setPublishModal(false),
                                  icon: {
                                    Icon: MemoCircleMinusIcon,
                                    ICprops: { color: "primary.900" },
                                  },
                                  textOne: "Are you sure you want to",
                                  textTwo: "revert",
                                  textThree: `the property ${property?.name}`,
                                  isComment: true,
                                  onConfirm: ({ comments }) => {
                                    handlePublishChange(
                                      property?.id,
                                      PROPERTY_PUBLISH_STATUS.revert,
                                      property?.name,
                                      comments
                                    );
                                    setPublishModal(false);
                                  },
                                });
                              }}
                            >
                              Revert
                            </Button>
                          )}
                        </>
                      )}
                      {(userRole?.isAdmin ||
                        userRole?.isSuperadmin ||
                        userRole?.isChecker) && (
                        <>
                          {userRole?.isChecker && (
                            <Button
                              height="4.3rem"
                              variant={"primaryOutline"}
                              disabled={!property?.[PROPERTY_STATUS.legal]}
                              px="2rem"
                              width="13rem"
                              onClick={() => {
                                setPublishModal({
                                  onClose: () => setPublishModal(false),
                                  icon: {
                                    Icon: MemoCircleMinusIcon,
                                    ICprops: { color: "primary.900" },
                                  },
                                  textOne: "Are you sure you want to",
                                  textTwo: "revert",
                                  textThree: `the property ${property?.name}`,
                                  isComment: true,
                                  onConfirm: ({ comments }) => {
                                    handlePublishChange(
                                      property?.id,
                                      PROPERTY_PUBLISH_STATUS.revert,
                                      property?.name,
                                      comments
                                    );
                                    setPublishModal(false);
                                  },
                                });
                              }}
                            >
                              Revert
                            </Button>
                          )}
                          {property.status?.toLowerCase() ===
                          PROPERTY_PUBLISH_STATUS.published ? (
                            <Button
                              height="4.3rem"
                              variant={"primaryOutline"}
                              px="2rem"
                              width="13rem"
                              onClick={() => {
                                setPublishModal({
                                  onClose: () => setPublishModal(false),
                                  icon: {
                                    Icon: MemoCircleCheckIcon,
                                    ICprops: { color: "primary.900" },
                                  },
                                  textOne: "Are you sure you want to",
                                  textTwo: "unpublish",
                                  textThree: `the property ${property?.name}`,
                                  isComment: true,
                                  onConfirm: ({ comments }) => {
                                    handlePublishChange(
                                      property?.id,
                                      PROPERTY_PUBLISH_STATUS.unpublished,
                                      property?.name,
                                      comments
                                    );
                                    setPublishModal(false);
                                  },
                                });
                              }}
                              disabled={userRole?.isChecker}
                            >
                              Unpublish
                            </Button>
                          ) : (
                            <Button
                              height="4.3rem"
                              variant={"primary"}
                              px="2rem"
                              width="13rem"
                              onClick={() => {
                                setPublishModal({
                                  onClose: () => setPublishModal(false),
                                  icon: {
                                    Icon: MemoCircleMinusIcon,
                                    ICprops: { color: "secondary.500" },
                                  },
                                  textOne: "Are you sure you want to",
                                  textTwo: "publish",
                                  textThree: `the property ${property?.name}`,
                                  onConfirm: () => {
                                    handlePublishChange(
                                      property?.id,
                                      PROPERTY_PUBLISH_STATUS.published,
                                      property?.name
                                    );
                                    setPublishModal(false);
                                  },
                                });
                              }}
                              disabled={
                                property?.status?.toLowerCase() !==
                                PROPERTY_PUBLISH_STATUS.drafted
                              }
                            >
                              Publish
                            </Button>
                          )}
                        </>
                      )}
                    </>
                    <Box
                      color="neutral.900"
                      cursor="pointer"
                      onClick={() =>
                        navigate(`/property-listing/add/${property?.id}`)
                      }
                    >
                      <MemoEyeShowIcon height="1.5rem" width="1.8rem" />
                    </Box>
                    {!userRole?.isChecker && !userRole?.isMaker && (
                      <Box
                        color="accents.100"
                        cursor="pointer"
                        onClick={() => {
                          setArchiveModal({
                            onClose: () => setArchiveModal(false),
                            icon: {
                              Icon: MemoArchive,
                              ICprops: { color: "accents.100" },
                            },
                            textOne: "Are you sure you want to",
                            textTwo: "archive",
                            textThree: `the property ${property?.name}`,
                            onConfirm: () => {
                              handleArchiveChange(
                                property?.id,
                                true,
                                property?.name
                              );
                              setArchiveModal(false);
                            },
                          });
                        }}
                      >
                        <MemoArchive />
                      </Box>
                    )}
                    {userRole?.isSuperadmin &&
                      property?.status ===
                        PROPERTY_PUBLISH_STATUS.published && (
                        <Box
                          color="accents.100"
                          cursor="pointer"
                          onClick={() => {
                            setExcelModal({
                              onClose: () => setExcelModal(false),
                              icon: {
                                Icon: MemoArchive,
                                ICprops: { color: "accents.100" },
                              },
                              textOne: "Are you sure you want to",
                              textTwo: "export the data into excel for",
                              textThree: `the property ${property?.name}`,
                              onConfirm: () => {
                                exportToExcelHandler("single", property?.id);
                                setExcelModal(false);
                              },
                            });
                          }}
                        >
                          <MemoDownload height="1.5rem" width="1.8rem" />
                        </Box>
                      )}
                    {(property?.status === PROPERTY_PUBLISH_STATUS.revert ||
                      property?.status ===
                        PROPERTY_PUBLISH_STATUS.unpublished) && (
                      <Box
                        color="neutral.900"
                        cursor="pointer"
                        onClick={() =>
                          setCommentModal({
                            propertyId: property?.id,
                            status: property?.status,
                            onClose: () => setCommentModal(false),
                          })
                        }
                      >
                        <MemoComments height="1.5rem" width="1.8rem" />
                      </Box>
                    )}
                  </Grid>
                </td>
              </tr>
            ))}
          </Table>
          {(!propertyListing || propertyListing?.length === 0) && <NoData />}
        </Loader>

        {total > PAGE_SIZE && <Pagination totalRecords={total} showPageSize />}
      </Card>
      {publishModal && <ConfirmationModal {...publishModal} />}
      {archiveModal && <ConfirmationModal {...archiveModal} />}
      {excelModal && <ConfirmationModal {...excelModal} />}
      {commentModal && <CommentsModal {...commentModal} />}
    </Box>
  );
};

export default Properties;
